<ng-container *ngIf="!item?.hide; else hidden">
  <div class="navigation-view">
    <div
      class="nav-link-list"
      *ngIf="!iframeService?.isInIframe"
      [class.nav-hidden]="isHidden"
      role="navigation"
      aria-label="Course">
      <div *ngFor="let link of item.links">
        <div *ngIf="item.link_list"></div>
        <div *ngIf="!item.link_list">
          <div
            class="navigation-item background-hover"
            role="button"
            [ngClass]="inRoute(link.link) ? 'primary-background-sidenav' : ''"
            routerLink="{{ link.link }}"
            [innerHTML]="
              link?.translation_key || link.text | translation | safeHtml
            "
            *ngIf="link.link && link.link.length > 0"></div>
          <div
            [innerHTML]="
              link?.translation_key || link.text | translation | safeHtml
            "
            *ngIf="!link.link || link.link.length == 0"></div>
        </div>
      </div>
      <div *ngFor="let tool of tools">
        <div
          class="navigation-item background-hover"
          role="button"
          [innerHTML]="
            link?.translation_key || tool.button?.text || tool.title
              | translation
          "
          (click)="launch(tool)"></div>
      </div>
    </div>
    <div
      class="view-column"
      style="padding-top: 8px"
      [ngClass]="{ 'view-column-iframe': iframeService?.isInIframe }"
      [class.nav-hidden]="isHidden">
      <button
        *ngIf="!iframeService?.isInIframe"
        pButton
        severity="contrast"
        size="small"
        (click)="toggle()"
        class="menu-toggle"
        attr.aria-label="Toggle {{ info.type }} menu visibility">
        <i *ngIf="isHidden" class="fas fa-chevron-right"></i
        ><i *ngIf="!isHidden" class="fas fa-chevron-left"></i>
      </button>
      <div class="breadcrumb-holder" *ngIf="!iframeService?.isInIframe">
        <span *ngFor="let link of breadcrumbs; let last = last">
          <a *ngIf="!last" routerLink="{{ link.link }}">{{
            getTitle(link) | friendlyType
          }}</a>
          <span *ngIf="!last" class="breadcrumb-seperator">
            <i class="fas fa-chevron-right" style="font-size: 10px"></i>
          </span>
          <span *ngIf="last">{{ getTitle(link) }}</span>
        </span>
      </div>
      <router-outlet (activate)="navRoute($event)"></router-outlet>
    </div>
  </div>
</ng-container>
<ng-template #hidden>
  <div class="breadcrumb-holder" *ngIf="!iframeService?.isInIframe">
    <span *ngFor="let link of breadcrumbs; let last = last">
      <a *ngIf="!last" routerLink="{{ link.link }}">{{
        getTitle(link) | friendlyType
      }}</a>
      <span *ngIf="!last" class="breadcrumb-seperator">
        <i class="fas fa-chevron-right" style="font-size: 10px"></i>
      </span>
      <span *ngIf="last">{{ getTitle(link) }}</span>
    </span>
  </div>
  <router-outlet (activate)="navRoute($event)"></router-outlet
></ng-template>
